import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-control-dynamic',
  templateUrl: './form-control-dynamic.component.html',
  styleUrls: ['./form-control-dynamic.component.css']
})
export class FormControlDynamicComponent implements OnInit {

  orderForm: FormGroup;
  items: FormArray;
  formErrors: any;
  validationMessages: any;
  myhobbies: any;
  constructor(private formBuilder: FormBuilder) {
    this.myhobbies = [
      {
        name: "Sports",
        value: "sports"
      },
      {
        name: "Music",
        value: "music",
        selected: true
      },
      {
        name: "Movie",
        value: "movie"
      },
      {
        name: "Reading",
        value: "reading"
      },
      {
        name: "Writing",
        value: "writing"
      }
    ];
  }

  ngOnInit(): void {
    this.orderForm = this.formBuilder.group({
      customerName: '',
      email: '',
      items: this.formBuilder.array([this.createItem()])
    });

  
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      skillName: ['', Validators.required],
      skillNameconfirm: ['', Validators.required],
      experienceInYears: ['', Validators.required],
      proficiency: ['', Validators.required],
      hobbies: this.createHobbies(this.myhobbies),
      selecthobbies: ''
    },
      {
        // Used custom form validator name
        validator: this.checknotmatch("skillName", "skillNameconfirm")
      }
    );
  }

  createHobbies(hobbiesInputs) {
    const arr = hobbiesInputs.map(hobby => {
      return new FormControl(hobby.selected || false);
    });
    return new FormArray(arr);
  }


  addItem(): void {
    this.items = this.orderForm.get('items') as FormArray;
    this.items.push(this.createItem());
  }

  removeItem(indexitem): void {
    this.items = this.orderForm.get('items') as FormArray;
    this.items.removeAt(indexitem);
  }

  checknotmatch(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }



  getvalueselect(traget, index) {
    this.items = this.orderForm.get('items') as FormArray;

    var checked = traget.checked; // true mean cheked
    if (checked == true) {
      var indextraget = this.myhobbies.findIndex(x => x.value == traget.value);
      var hobbiesall = this.items.controls[index].value.hobbies;
      for (var i = 0; i < hobbiesall.length; i++) {
        if (i != indextraget) {
          var controlsgroup = this.items.controls[index] as FormGroup;
          var contraolarray = controlsgroup.controls.hobbies as FormArray;
          // set checkbox
          contraolarray.controls[i].setValue(false);
        }
      }
    } else {
      var controlsgroup = this.items.controls[index] as FormGroup;
    }

    
    var hobbiesselect = this.items.controls[index].value.hobbies.findIndex(x => x == true);
    if (hobbiesselect != -1) {
      this.items.controls[index].value.selecthobbies = this.myhobbies[hobbiesselect].value;
    } else {
      this.items.controls[index].value.selecthobbies = '';

    }
  }




}
